import React, { useEffect, useState,useRef } from "react";
import BottomNav from "../components/BottomNav";
import Container from "../components/Container";
import Description from "../components/Description";
import FinancialHealthCheckup from "../components/FinancialHealthCheckup";
import Heading from "../components/Heading";
import Input from "../components/Input";
import PieGraph from "../components/PieGraph";
import { BarChart, Bar, XAxis, YAxis, ReferenceLine, Cell, ResponsiveContainer } from 'recharts';
import ResultInput from "../components/ResultInput";
import ValueContainer from "../components/ValueContainer";
import { kFormatter } from "../libs";
import DescriptionItem from "../components/DescriptionItem";
import {useSelector,useDispatch} from 'react-redux'
import  { actions } from '../store/index'
import YourFHC from "../components/YourFHC";
import { Link } from "react-router-dom";


const KFormater = (num) => Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill="#404EED" textAnchor="middle" dy={value < 0 ? 16 : -6} >{`${value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}</text>;
};

const SFG = () => {

    const counter=useSelector((state)=>state.formdata)
    const dispatch=useDispatch()
    const hasCodeExecuted = useRef(false);


    const [formData, setFormData] = useState({
        M1: 0,
        M2: 0,
        M3: 0,
        M4: 0,
        T1: 0,
        T2: 0,
        T3: 0,
        T4: 0,
       

    });

    const [data,setData]=useState({
        GL1: 0,
        GL2: 0,
        GL3: 'Yes',
        GL4: 0,
        GL5: 0,
        C1: 0,
        C2: 0,
        C3:0,
        P: 0,
        NewM3: 0,
        S: 0 
    })

    const [resultData, setResultData] = useState({
        R1: 0,
        R2: 0,
        R3: 0,
        R4: 0,
        R5: 0,
        R2a:0,
        R4a:0,
        R1a:0,
        flag:true
    });

    const[flag,setFlag]=useState(true)

    const[GL3,setGL3]=useState('Yes')

    const handleSelectChange = (event) => {
        // console.log(selectedOption)
        console.log(event.target.value)
         setGL3(event.target.value)
    };
    
    const [Slack, setSlack] = useState(0);
    const [Slack2, setSlack2] = useState(0);
    const [Networth, setNetworth] = useState(0);

    const changeHandler = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const dataChangeHandler = (e) => {

        setData({
            ...data,
            [e.target.id]: e.target.value
        });

     

    };

    const update=()=>
    {
        Object.keys(counter).length>0?
        setFormData(counter):
        setFormData(formData)
    }


    function PMT(ir, np, pv, fv) {
        /*
        ir - interest rate per month
        np - number of periods (months)
        pv - present value
        fv - future value (residual value)
        */
        const pmt = (ir * (pv * Math.pow((ir + 1), np) + fv)) / ((ir + 1) * (Math.pow((ir + 1), np) - 1));
        // console.log(pmt)
        console.log( ((Number(formData.H4) + Number(formData.H5) + Number(formData.H6)) / 12))

        // alert(pmt)
        return pmt;
    }
    function PMT1(rate, nper, pv) {
        // Calculate the payment amount
        var pmtAmount = (pv * rate) / (1 - Math.pow(1 + rate, -nper));
        
        // Return the payment amount with two decimal places
        console.log(pmtAmount)
        return pmtAmount.toFixed(2);
      }
      function PMT2 (ir, np, pv, fv ) {
        /*
        ir - interest rate per month
        np - number of periods (months)
        pv - present value
        fv - future value (residual value)
        */
    //    console.log((H4 + H5 + H6) / 12)
        let pmt = ( ir * ( pv * Math.pow ( (ir+1), np ) + fv ) ) / ( ( ir + 1 ) * ( Math.pow ( (ir+1), np) -1 ) );
        return pmt;
       }
     
    
       function PMT3(rate, nper, pv, type) {
        var pmt = (rate * pv) / (1 - Math.pow(1 + rate, -nper));
        if (type === 1) {
          pmt /= (1 + rate);
        }
        return -pmt;
      }

    
    useEffect(() => {
        if (!hasCodeExecuted.current) {

            update()
            hasCodeExecuted.current = true;

            window.scrollTo(0, 0);

        }
        const { M1, M2, M3, M4, T1, T2, T3, T4, H1, H2, H3, H4, H5, H6, H7, H8, H9 } = formData;
        const val=((PMT(((Number(H8)) /100)/ 12, Number(H9)*12 , Number(H1),0)) + ((Number(H4) + Number(H5) + Number(H6)) / 12))

        setResultData({
            R1: (Number(M3) / Number(M1)) * 100,
            R2: (Number(T1) / ((Number(M2) + Number(M3) + Number(M4)))) *100,
            R3: ((Number(T1) + Number(T2)) / (Number(T3) + Number(T4)) * 100),
            R4: (Number(T1) / (Number(M3) + Number(M4)) * 100),
            R5: (Number(M4) / Number(M1) * 100),
            // BR3: (Number(val) / Number(H2))*100,
            // R1a: (Number(M3) / Number(M1))*100,
            // R2a: (Number(T1) / (Number(M2) + Number(M3) + Number(val)))*100,
            // R3a: ((Number(T1) + Number(T2)) / (Number(T3) + Number(H1) - Number(H7)))*100,
            // R4a: (Number(T1) / (Number(M3) + Number(val)))*100,
            // R5a: (Number(val) / Number(M1))*100,
            // SME: (6 * (Number(val) + Number(M2) +Number(M3)))
        });

    
        let resultR2=(Number(T1) / ((Number(M2) + Number(M3) + Number(M4)))) *100
        // alert(resultR2)
        if(Number(resultR2).toFixed(0)>300)
        {
            let C1=Number(formData.T1)-3*(Number(formData.M2)+Number(formData.M3)+Number(formData.M4))
            data.C1=C1
            data.C2=Number(C1)-Number(formData.T3)
            data.C3=Number(data.GL1)-Number(data.C2)
            data.NewM3=Number(formData.M3)
            resultData.R1a=(Number(formData.M3)/Number(formData.M1)*100)
            
        }
        setCartData([
            {
            name: `${temp[0].month} ${temp[0].year}`,
            value: Number(T1),
            color: "#404EED"
        },
        {
            name: `${temp[1].month} ${temp[1].year}`,
            value: Number(T2),
            color: "#404EED"
        },
        {
            name: `${temp[2].month} ${temp[2].year}`,
            value: -Number(T3),
            color: "#404EED"
        },
        {
            name: `${temp[3].month} ${temp[3].year}`,
            value: -Number(T4),
            color: "#404EED"
        },
        {
            name: `${temp[4].month} ${temp[4].year}`,
            value: Number(T1),
            color: "#404EED"
        },
        {
            name: `${temp[5].month} ${temp[5].year}`,
            value: Number(T2),
            color: "#404EED"
        },
        {
            name: `${temp[6].month} ${temp[6].year}`,
            value: -Number(T3),
            color: "#404EED"
        },
        {
            name: `${temp[7].month} ${temp[7].year}`,
            value: -Number(T4),
            color: "#404EED"
        },
        {
            name: `${temp[8].month} ${temp[8].year}`,
            value: Number(T1),
            color: "#404EED"
        },
        {
            name: `${temp[9].month} ${temp[9].year}`,
            value: Number(T2),
            color: "#404EED"
        },
        {
            name: `${temp[10].month} ${temp[10].year}`,
            value: -Number(T3),
            color: "#404EED"
        },
        {
            name: `${temp[11].month} ${temp[11].year}`,
            value: -Number(T4),
            color: "#404EED"
        }
    ]);
    let slack= Number(M1) - (Number(M2) + Number(M3) + Number(M4))






    //  slack = slack.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    //  slack = slack.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
//  const networthNoDecimal = slack.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    
// resultData.R2a = (Number(formData.T1) / (Number(formData.M2) + Number(data.NewM3) +Number(formData.M4)))*100
// resultData.R4a =(Number(formData.T1) / (Number(data.NewM3) + Number(formData.M4)))*100

dispatch(actions.updateFormData(formData))

    setSlack(slack);
    data.S=Number(slack)
    // data.P= -PMT(Number(data.GL4)/12,Number(data.GL5)*12,Number(data.GL1),0) 
    // setSlack2(Number(M1) - ((Number(M2) + Number(M3) + Number(resultData.HOC))));
    setSlack2(data.GL3)
    // console.log(Slack2)
    setNetworth((Number(T1) + Number(T2)) - Number(T3));
    console.log(resultData.HOC)
}, [formData, Slack, Slack2,data.S,data.GL3,GL3,resultData.R1a,data]);









        var temp=[]
        const d = new Date();
// console.log(d.getMonth());
   const m=d.getMonth()
   const y=d.getFullYear()
   const mo = [
    {no:1,month:"January",year:y},
    {no:2,month:"February",year:y},
    {no:3,month:"March",year:y},
    {no:4,month:"April",year:y},
    {no:5,month:"May",year:y},
    {no:6,month:"June",year:y},
    {no:7,month:"July",year:y},
    {no:8,month:"August",year:y},
    {no:9,month:"September",year:y},
    {no:10,month:"October",year:y},
    {no:11,month:"November",year:y},
    {no:12,month:"December",year:y}];
   console.log(y)
      mo.map((index)=>
      {
        if(index.no>m)
        {
            temp=[...temp,index]
            // console.log(index)
        }
      })
      mo.map((index)=>
      {
        if(index.no<=m)
        {
        
           index.year+=1
            temp=[...temp,index]
            // console.log(index)
        }
      })
    
      temp.map((index)=>
      {

        console.log(index.month)
      })
      console.log(temp.length)
    const [chartData, setCartData] = useState([
        {
        name: `${temp[0].month} ${temp[0].year}`,
        value: Number(formData.T1),
        color: "#404EED"
    },
    {
        name: `${temp[1].month} ${temp[1].year}`,
        value: Number(formData.T2),
        color: "#404EED"
    },
    {
        name: `${temp[2].month} ${temp[2].year}`,
        value: -Number(formData.T3),
        color: "#404EED"
    },
    {
        name: `${temp[3].month} ${temp[3].year}`,
        value: -Number(formData.T4),
        color: "#404EED"
    },
    {
        name: `${temp[4].month} ${temp[4].year}`,
        value: Number(formData.T1),
        color: "#404EED"
    },
    {
        name: `${temp[5].month} ${temp[5].year}`,
        value: Number(formData.T2),
        color: "#404EED"
    },
    {
        name: `${temp[6].month} ${temp[6].year}`,
        value: -Number(formData.T3),
        color: "#404EED"
    },
    {
        name: `${temp[7].month} ${temp[7].year}`,
        value: -Number(formData.T4),
        color: "#404EED"
    },
    {
        name: `${temp[8].month} ${temp[8].year}`,
        value: Number(formData.T1),
        color: "#404EED"
    },
    {
        name: `${temp[9].month} ${temp[9].year}`,
        value: Number(formData.T2),
        color: "#404EED"
    },
    {
        name: `${temp[10].month} ${temp[10].year}`,
        value: -Number(formData.T3),
        color: "#404EED"
    },
    {
        name: `${temp[11].month} ${temp[11].year}`,
        value: -Number(formData.T4),
        color: "#404EED"
    },
    
    
]);



    return (
        <div className="w-full">
            <div className="bg-gradient-to-b h-72 from-primary to-patric-blue">
                <Container classes={"flex flex-col p-4 px-5 space-y-6 md:space-y-0  md:py-10 md:flex-row items-center w-full justify-between"}>
                    <div className="w-full md:w-auto">
                        <Link to={'/'}>
                        <img src="./assets/images/logo-white.png" alt="logo" />
                        </Link>
                        
                        </div>
                    <h1 className="text-white font-bold text-center text-2xl md:text-4xl">Saving for a Goal</h1>
                    <div className="hidden md:block"></div>
                </Container>
                <div className="text-white  text-center mb:mx-0 mx-5 md:ml-40 -mt-3 md:-mt-7 text-lg md:text-2xl">You have the goal, now give it a plan</div>

            </div>
            <Container classes={"-mt-24 md:-mt-32 py-10 space-y-6"}>
                <div className="flex flex-col md:flex-row items-start space-y-10 md:space-y-0 md:space-x-6">
                    <div className="flex-1 w-full md:flex md:space-x-10 md:space-y-0 space-y-10 ">
                        <div className="shadow-md p-6 bg-white space-y-6">
                            <Heading text={"Basic Financial Inputs"} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">
                                <Input type={"number"} id={"M1"} value={formData.M1} label={"Monthly Income"} onChange={changeHandler} />
                                <Input type={"number"} id={"T1"} value={formData.T1} label={"Total Savings (Liquid Funds)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M2"} value={formData.M2} label={"Monthly Expenses"} onChange={changeHandler} />
                                <Input type={"number"} id={"T2"} value={formData.T2} label={"Stocks, bonds, real estate etc."} onChange={changeHandler} />
                                <Input type={"number"} id={"M3"} value={formData.M3} label={"Monthly Debt pmt (credit card, car etc)"} onChange={changeHandler} />
                                <Input type={"number"} id={"T3"} value={formData.T3} label={"Total Debt (except mortgage)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M4"} value={formData.M4} label={"Housing / Rent, Tax, Inurance"} onChange={changeHandler} />
                                <Input type={"number"} id={"T4"} value={formData.T4} label={"Mortgage Balance"} disable onChange={changeHandler} />
                            </div>

                         
                        </div>


                     
              <YourFHC R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Slack={Slack}/>



                      
                    </div>

                </div>



                <div className="flex-1 w-full md:flex-none space-y-6">
                    <div className="shadow-md p-6 bg-white space-y-12">
                        <div className="hidden md:block">

                            <Heading text={"Desired Goal"} icon={"financial-input"} />
                        </div>
                        <div className="block md:hidden md:px-0 md:text-center">

                            <Heading text={"Desired Goal"} classes={' '} />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 gap-4 md:gap-y-8 lg:gap-x-28 md:ml-7  md:px-0">
                        <div>
                        <label htmlFor="dropdown" className="text-sm ml-2">What is your Goal?</label>
                        <select id="dropdown" className="bg-bright-gray/50  text-gray-900 text-sm  py-3 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  focus:outline-primary outline-primary">
                            <option selected className='peer-focus:text-primary text-chinese-black/70 hidden xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm text-black '>Select</option>
                            <option value="Education" className='text-black' >Education</option>
                             <option value="Travel" className='text-black'>Travel</option>
                            <option value="Investment" className='text-black'>Business</option>
                            <option value="Investment" className='text-black'>Buying Home</option>
                             <option value="Other" className='text-black'>Other</option>
                            </select>    
                            </div>
                           <Input type={"number"} id={"GL1"} value={data.GL1} label={"Amount of money needed to achieve your goal"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"GL2"} value={data.GL2} label={"Time-Line for achieving your goal (years)"} onChange={dataChangeHandler} />
                            <div>
                        <label htmlFor="dropdown" className="text-sm ml-2">Do you prefer to finance this goal through a Loan?</label>
                        <select id="dropdown" className="bg-bright-gray/50  text-gray-900 text-sm  py-3 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  focus:outline-primary outline-primary" onChange={handleSelectChange}>
                            <option  className='peer-focus:text-primary text-chinese-black/70 hidden xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm text-black '>Select</option>
                            <option selected value="Yes" className='text-black font-bold' >Yes</option>
                             <option value="No" className='text-black font-bold'>No</option>
                           
                            </select>    
                            </div>                           
                            <Input type={"number"} id={"GL4"} value={data.GL4} label={"If yes, approx Interest Rate for Loan"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"GL5"} value={data.GL5} label={"If yes, tenure of the loan(years)"} onChange={dataChangeHandler} />
     
                        </div>


                    </div>
                </div>

                <div className="block md:flex pt-10 px-5">

                    <div className="hidden md:block w-7/12">
                        <PieGraph heading="Expenses & Surplus" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                    </div>
                    <div className="md:hidden">
                        <PieGraph heading="Expenses & Surplus" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                    </div>
                    <div className="md:pl-14 mt-10 md:mt-24">
                    { resultData.R1>40 ? <DescriptionItem falseText={"Your monthly Debt payments are high compared to your Income."} rightText={""} condition={resultData.R1 <= 40} /> : null}
                    <br></br>
                    { formData.T3> (0.3*(Number(formData.T1))+Number(formData.T2)) ? <DescriptionItem falseText={"You may have very high Total debt."} rightText={""} condition={formData.T3< (0.3*(Number(formData.T1))+Number(formData.T2))} /> : null}
                    <br></br>
                    { (resultData.R1<40 && formData.T3 < (0.3*(Number(formData.T1))+Number(formData.T2))) ? <DescriptionItem falseText={""} rightText={"Your monthly Debt payments are manageable given your Income and your Total Debt is reasonable."} condition={resultData.R1<40 & formData.T3 < (0.3*(Number(formData.T1))+Number(formData.T2)) } /> : null}
                    <br></br>
                    { !(isNaN(resultData.R2) || resultData.R2 === Infinity || resultData.R2<0)? <DescriptionItem falseText={"You have less than 3 months of Total Savings to cover your expenses and debt obligations."} rightText={"You have 3+ months of Total savings to cover expenses and debt payments. Maintain this as your emergency fund."} condition={(Number(resultData.R2)>300)} />:null}
                  </div> 





                </div>

  
              {(isNaN(resultData.R2) || resultData.R2 === Infinity || resultData.R2<0 ) ?  '':Number(resultData.R2).toFixed(0)>299 && Number(resultData.R2).toFixed(0)<301?'':
              
              

                <div className="flex-1  md:flex-none space-y-6 md:w-1/2 md:ml-96">
                  

              
                   <div className="shadow-md p-6 bg-white space-y-8  ">
                        <div className="md:block text-center">

                            <Heading text={"Recommendations"}  />
                        </div>

                    
                        <div className="text-center px-12 font-bold">
                        {
                           
                            formData.T3>(0.3*(Number(formData.T1)+Number(formData.T2))) && formData.T3>0?
                            <div >
                         <p className="hidden">

{resultData.flag=(true)}
     </p>
                            <p>
                                You have too much Debt, please pay off or reduce this debt before saving for your desired goal.              
                                </p>
                                </div>
                           :null
                        }
                        </div>

                        
                        <div className="text-center px-12 font-bold">
                        {
                            resultData.R2<300 && resultData.R2>0?
                            <div >
                            <p className="hidden">

{resultData.flag=(true)}
     </p>
                        <p>
                            'You do not have enough Emergency Fund savings. Please build your Emergency Fund savings to at least 3 months of expenses before saving for your desired goal.'    
                                   
                            </p>
                            </div>
                           :null
                        }
                        </div>


                        {resultData.R2>300 && formData.T3<(0.3*(Number(formData.T1)+Number(formData.T2)))   ?    
                           <div>
                            <p className="hidden">

                       {resultData.flag=(false)}
                            </p>
                     <div className="text-center font-bold mb-2">
                        {
                            resultData.R2 && formData.T3<(0.3*(Number(formData.T1)+Number(formData.T2))) ?
                            `You have ${data.C1} cash after emergency fund.`:""
                        }
                     </div>  


              {
                data.C1>formData.T3?
              
                     <div>

                  
                     <div className="text-center px-12 font-bold">
                        {
                            data.C1>formData.T3?
                           ` You can use a portion of ${data.C1} to first pay off your debt ${formData.T3} Remaining Cash that you can use for your goal is ${data.C2}`                     
                           :''
                        }
                        </div>  	
                     <div className="text-center font-bold flex my-5 px-12 ">
                        {data.C2>data.GL1?
                                            <div>

                                                <p>
                                                    You can use portion of remaining cash ${data.C2} for  your Goal. You have achieved your goal  with  your savings. <b className="p-1 rounded-3xl  text-jungle-green bg-custom-color ">Congratulations!</b>
                                                </p>
                                                {/* <p className="rounded-3xl  text-jungle-green bg-custom-color absolute   ">  Congratulations! </p> */}
                                            </div>
                       :<div>
                        <p>You can now use ${data.C2} for your goal. Remaining goal amount, ${data.C3}</p>
                        {   Slack>0? 
                        GL3==='No' ? <div>
                                            It will take you {Math.ceil(Number((data.C3) / Number(Slack)))} months to achieve your goal
                                            using the slack in your budget 
                          
                          <p className="hidden">
                              {data.S= 0}
                              {console.log(data.S)}
                            </p>
                        </div> :
                    <div>
                    
                    <p className="hidden">
                        {data.P= PMT((Number(data.GL4)/100)/12,Number(data.GL5)*12,Number(data.GL1),0) }
                    </p>

                
                        {data.P>Slack?`You can afford this loan. Better to use Slack ${Slack} to save for your goal first.`
                        :
<div>

                        <div className="hidden">
                       {data.NewM3=Number(data.P)+Number(formData.M3)}
                       {resultData.R1a=(Number(data.NewM3)/Number(formData.M1)*100)}
                    
                       {data.S =(Number(Slack)-Number(data.P))}
                      
                       {/* {console.log(data.S)} */}
                       
                       
                        </div>
                        {<p>Your monthly payemt will be ${data.P.toFixed(0)}.</p>}
                        </div>
                        
                        }
                       
                    </div>

                 

                        :'You do no have enough slack each month to save for your goal. Try reducing your expenses in order to start saving for your goal.'}


                       </div>  
                        
                    }
                     
                  
                        {/* <div className="rounded-3xl w-40 text-jungle-green bg-custom-color absolute md:ml-72 ml-20 md:mt-12 mt-28  ">  Congratulations!  </div> */}
                                   </div> 

                     
                     <div className="text-center font-bold px-12">
                       
                     </div>  
                        

                     </div>:

                    <div className="text-center px-12 font-bold">
                        {
                            data.C1<formData.T3?
                            <div>
                              <p className="hidden"> {data.S=Slack}</p>
                             You can pay off a portion ${data.C1} of your debt. First use ${data.S} to pay off debt in {Math.ceil(((Number(formData.T3)-Number(data.C1))/Number(Slack)))} months, then use ${Slack} to
                            save for your goal. It will take you {Math.ceil((Number(data.GL1)/Number(Slack)))} months to reach your goal after paying off debt.         
                                </div>
                            :''
                        }
                        </div>  	
}
                         </div>:''}

                        </div>
                </div>}
        















                <div className="space-y-20">

               


                    {
       resultData.flag===false?
                    <div className=" md:flex justify-between md:space-x-24">
     


                        <div className="w-full md:flex-1 p-5  shadow-md   ">
                            <div className="px-0">

                                <Heading text="Your Financial Health Checkup" classes={"items-center px-10 md:px-4"} />
                            </div>
                            <div className="flex justify-center">


                            </div>
                            <div className="flex justify-center p-5">

                            <div className=" md:w-1/2 md:px-0 px-10 space-y-7">
                                {/* {alert(Number(data.NewM3)/Number(formData.M1)*100)} */}
                                {/* {alert(resultData.R1a)} */}
                                <p className="hidden">
                                    {/* {alert(data.NewM3)}
                                     */}
                                {resultData.R1a=(Number(data.NewM3)/Number(formData.M1)*100)}
                                     {resultData.R2a = (Number(formData.T1) / (Number(formData.M2) + Number(data.NewM3) +Number(formData.M4)))*100}
                                     {resultData.R4a =(Number(formData.T1) / (Number(data.NewM3) + Number(formData.M4)))*100}
                                </p>
                                <ResultInput label={'Debt / Income ratio'} value={isNaN(resultData.R1a) || resultData.R1a === Infinity || resultData.R1a<0 ? 0 : resultData.R1a.toFixed(2) + '%'} tooltip={"How much of your income is spent on Debt Payments? Recommended < 20%"} />
                                  <ResultInput label={'Expense coverage ratio by savings'} value={isNaN(resultData.R2a) || resultData.R2a === Infinity || resultData.R2a<0 ? 0 : resultData.R2a.toFixed(2) + '%'}  tooltip={"How many times does your savings cover monthly expenses(expenses, debt and rent)? Recommended>300% (3 months)"}/>
                                    <ResultInput label={'Assets / Liabilities'} value={isNaN(resultData.R3) || resultData.R3 === Infinity || resultData.R3 <0 ? 0 : resultData.R3.toFixed(2) + '%'} tooltip={"Ratio of what you have vs what you owe. Recommended>100% (positive net worth)"} />
                                    <ResultInput label={'Assets / (Rent + Debt) coverage'} value={isNaN(resultData.R4a) || resultData.R4a === Infinity || resultData.R4a<0 ? 0 : resultData.R4a.toFixed(2) + '%'} tooltip={"How many times can your obligations be covered by assets? Recommended > 1200% (one year) "}/>
                                    <ResultInput label={'Housing cost ratio'} value={isNaN(resultData.R5) || resultData.R5 === Infinity || resultData.R5<0 ? 0 : resultData.R5.toFixed(2) + '%'} tooltip={"How much of your income is spent on housing costs? Recommended < 30% "}/>
                                    <ResultInput label={'Slack in Budget'} value={isNaN(data.S) || Number(data.S)< 0 || data.S === Infinity ? 0 : data.S.toFixed(0)} isLast tooltip={"This is the surplus each month which can be used for goal planning"}/>


                                </div>

                            </div>
                        </div>

                        <div className="  w-full  md:w-1/2 pt-5 md:block  justify-center px-0 md:px-0 ">
                            <PieGraph heading="Expenses & Surplus" subheading="" M1={formData.M1} M2={formData.M2} M3={(data.NewM3).toFixed(0)} M4={formData.M4} slack={data.S.toFixed(0)} />
                        </div>
                    

                    </div>
:''}


                   
                   
                    <BottomNav />
                </div>
            </Container>
        </div>
    );
};

export default SFG;